module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.9.2-274.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.9.2.md
// module id = 715
// module chunks = 224